module.exports = __webpack_public_path__ + "static/Home-dbe932b46fd01b815c8bc280b8efd99e.jpg";